import { render, staticRenderFns } from "./convert.vue?vue&type=template&id=4a870e23&"
import script from "./convert.vue?vue&type=script&lang=js&"
export * from "./convert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports